import React, {useEffect, useState} from "react";
import {Button, Col, Modal, Row, Spinner} from "react-bootstrap";
import {useSelector} from "react-redux";
import axios from "axios";
import {toast} from "react-toastify";
import {isEmpty} from "../../../../_helpers/commonFunctions";
import {MdCancel} from "react-icons/md";

const UploadMT940Modal = ({show, setShow, selectedBank}) => {
    const company = useSelector(state => state.COMPANY_DATA.company);
    const [requestData, setRequestData] = useState({
        mt940: "",
        fileName: "",
    })
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!show) setRequestData({...requestData, mt940: "", fileName: ""});
    }, [show]);

    const handleOnChange = (e, type, name) => {
        if (type === "file") {
            if (name === "mt940") {
                const selectedFile = e.target.files[0];
                if (!selectedFile) return;
                const fileName = selectedFile.name;
                const isPdf = selectedFile.type === "application/pdf" || fileName.endsWith(".pdf");
                const reader = new FileReader();
                reader.onload = (e) => {
                    let fileContents = e.target.result;
                    if (isPdf && typeof fileContents === "string") fileContents = fileContents.split(",")[1];
                    setRequestData({
                        ...requestData,
                        mt940: fileContents,
                        fileName: fileName
                    });
                };
                reader.onerror = (e) => {
                    console.log(e);
                    toast.error("Σφάλμα κατά την ανάγνωση αρχείου.");
                }
                if (isPdf) reader.readAsDataURL(selectedFile);
                else reader.readAsText(selectedFile);
            }
        }
    }

    const handleUpload = () => {
        setLoading(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/accounting/upload-mt940`, {
            ...requestData,
            company: company.id,
            bankId: selectedBank.value,
            bankIBAN: selectedBank.iban,
        }).then((res) => {
            if (res.data.status === "200") {
                toast.success("Επιτυχής εισαγωγή.");
                setShow(false);
                handleReset();
            } else {
                toast.error(res.data.message);
            }
            setLoading(false);
        }).catch((err) => {
            setLoading(false);
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const handleReset = () => {
        setRequestData({
            ...requestData,
            mt940: "",
            fileName: "",
        })
        document.getElementById("mt940_file_upload").value = null;
    }

    const hasSelectedFile = !isEmpty(requestData.mt940);

    return (
        <Modal show={show} onHide={() => setShow(false)} backdrop={"static"}>
            <Modal.Header closeButton>
                <Modal.Title>Ανέβασμα αρχείου τύπου MT940</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Col md={hasSelectedFile ? 10 : 12}>
                        <input
                            type={"file"}
                            id={"mt940_file_upload"}
                            className={"form-control"}
                            style={{lineHeight: "1.7"}}
                            onChange={(e) => handleOnChange(e, "file", "mt940")}
                            disabled={hasSelectedFile}
                        />
                    </Col>
                    {hasSelectedFile && (
                        <Col md={2}>
                            <Button style={{marginTop: "3px"}} size={"sm"} onClick={() => handleReset()} title={"Αποεπιλογή αρχείου"}>
                                <MdCancel />
                            </Button>
                        </Col>
                    )}
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-primary" onClick={() => setShow(false)}>
                    Κλείσιμο
                </Button>
                <Button variant="primary" onClick={() => handleUpload()} disabled={!hasSelectedFile || loading}>
                    Εισαγωγή συναλλαγών {loading && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} />}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default UploadMT940Modal;
